import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, withKeys as _withKeys } from "vue"
import _imports_0 from '@/app/ui/assets/svg/close-white.svg'


const _hoisted_1 = { class: "flex justify-center items-center py-6 fixed inset-0 z-70 outline-none focus:outline-none w-screen\n      " }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4",
  alt: "close"
}, null, -1)
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = {
  key: 2,
  class: "w-auto bg-white p-3 mt-1 rounded-md"
}
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "px-1" }, [
  /*#__PURE__*/_createVNode("p", { class: "font-bold text-gray-lp-300 text-16px" }, "Saya sudah membaca & memahami informasi yang disampaikan diatas."),
  /*#__PURE__*/_createVNode("p", { class: "font-normal text-gray-lp-600 text-14px" }, "* Untuk keterangan lebih lanjut hubungi whatsapp +62 811-1956-1000 atau email help@thelionparcel.com ")
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "opacity-50 fixed inset-0 z-60 bg-black" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_SplideSlide = _resolveComponent("SplideSlide")!
  const _component_Splide = _resolveComponent("Splide")!

  return (_ctx.modelValue)
    ? (_openBlock(), _createBlock("div", {
        key: 0,
        class: "font-montserrat",
        onKeydown: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)), ["esc"]))
      }, [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", {
            class: "absolute w-auto bg-gray-lp-500 p-4 rounded-full top-0 right-0 mt-4 mr-10 cursor-pointer",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
          }, [
            _hoisted_2
          ]),
          (_ctx.single)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: "flex justify-center",
                style: `height: ${_ctx.maxHeightDefault - 100}px`
              }, [
                _createVNode("img", {
                  src: _ctx.image,
                  class: "object-none cursor-pointer rounded",
                  alt: _ctx.item
                }, null, 8, ["src", "alt"])
              ], 4))
            : (_openBlock(), _createBlock(_component_Splide, {
                key: 1,
                options: {
          rewind: true,
          type: 'fade',
          lazyLoad: 'nearby',
          focus: 'center',
          arrows: _ctx.newData.length > 1,
          pagination: _ctx.newData.length > 1,
          start: _ctx.image ? _ctx.newData.findIndex(x => x.image === _ctx.image) : 0,
          classes: {
            prev: 'splide__arrow--prev prev-arrow',
            next: 'splide__arrow--next next-arrow'
          }
        },
                class: "mt-5 w-13/20 md:w-3/4",
                style: `height: ${_ctx.maxHeightDefault - 40}px`
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.newData, (item, index) => {
                    return (_openBlock(), _createBlock(_component_SplideSlide, { key: index }, {
                      default: _withCtx(() => [
                        _createVNode("div", {
                          class: "flex items-center",
                          style: `height: ${_ctx.maxHeightDefault - 70}px`
                        }, [
                          _createVNode("div", _hoisted_3, [
                            (_ctx.isCustom && index === 0)
                              ? _renderSlot(_ctx.$slots, "default", { key: 0 })
                              : (_openBlock(), _createBlock("img", {
                                  key: 1,
                                  src: item.type === 'pdf' ? require(`@/app/ui/assets/images/default-pdf.jpeg`) : _ctx.formatSourceImage(item.image),
                                  class: 
                  `${
                    item.url ? 'cursor-pointer' : ''
                  } rounded-lg w-full h-screen object-contain translate-x-1/2`
                ,
                                  alt: item,
                                  onClick: ($event: any) => (_ctx.onClickImage(item.url))
                                }, null, 10, ["src", "alt", "onClick"])),
                            (_ctx.isTerm)
                              ? (_openBlock(), _createBlock("div", _hoisted_4, [
                                  _createVNode("div", _hoisted_5, [
                                    _createVNode("div", null, [
                                      _createVNode(_component_Checkbox, {
                                        id: "term",
                                        modelValue: _ctx.isRead,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isRead = $event)),
                                        binary: true,
                                        onClick: _ctx.clickCheckBoxForGTM
                                      }, null, 8, ["modelValue", "onClick"])
                                    ]),
                                    _hoisted_6
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ], 4)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["options", "style"]))
        ]),
        _hoisted_7
      ], 32))
    : _createCommentVNode("", true)
}